module.exports = __webpack_public_path__ + "static/img/company_white.9e4b8d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company_white.png
// module id = 5sWD
// module chunks = 1